import { ActionTypes } from "../contants/action-types";
import supabase from "../../supabase";
import { v4 as uuidv4 } from 'uuid';

export const fetchApplications = (params) => async (dispatch) => {
    if(params){
        let { data: applications, error } = await supabase
            .from('applications')
            .select('*')
            .order('id', {ascending: false})
            .range(params.start,params.end)
        let { data: applicationscount, error2 } = await supabase
            .from('applications')
            .select('*')
            .order('id', {ascending: false})
        if(applications && applicationscount){
            dispatch({ type: ActionTypes.FETCH_APPLICATIONS, payload: applications });
            return {data:applications,success:true,count:applicationscount.length}
        }else if(error){
            return {error:error,success:false}
        }
    }
    let { data: applications, error } = await supabase
        .from('applications')
        .select('*')
        .order('id', {ascending: false})
    if(applications){
        dispatch({ type: ActionTypes.FETCH_APPLICATIONS, payload: applications });
        return {data:applications,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};

export const filterApplications = (param) => async (dispatch) => {
    let finalData = [];
    const callApi = async(item) =>{
        let { data: applications, error } = await supabase
            .from('applications')
            .select("*")
            .ilike(item, `%${param.search}%`)
            .order('id', {ascending: false})
        if(applications){
            applications.forEach((item)=>{
                finalData.push(item)
            })
        }else if(error){
            return{error:error,success:false}
        }
    }
    if(param && param.end){
        const callApi = async(item) =>{
            let { data: applications, error } = await supabase
                .from('applications')
                .select("*")
                .ilike(item, `%${param.search}%`)
                .order('id', {ascending: false})
            if(applications){
                applications.forEach((item)=>{
                    finalData.push(item)
                })
            }else if(error){
                return{error:error,success:false}
            }
        }
        await callApi('name')
        await callApi('email')
        await callApi('position')
        await callApi('phone')
        let finalData2 = [];
        finalData.forEach((item)=>{
            if(!finalData2.find(_item=>_item.id === item.id)){
                finalData2.push(item)
            }
        })
        let finalData3 = []
        finalData2.forEach((item,index)=>{
            if(index>=param.start && index<=param.end){
                finalData3.push(item)
            }
        })
        dispatch({ type: ActionTypes.FETCH_APPLICATIONS, payload: finalData3 });
        return {data:finalData3,success:true,count:finalData2.length}
    }
    await callApi('name')
    await callApi('email')
    await callApi('position')
    await callApi('phone')
    let finalData2 = [];
    finalData.forEach((item)=>{
        if(!finalData2.find(_item=>_item.id === item.id)){
            finalData2.push(item)
        }
    })
    dispatch({ type: ActionTypes.FETCH_APPLICATIONS, payload: finalData2 });
    return{data:finalData2,success:true}
}

export const addApplication = (applicationdata) => async (dispatch) => {
    const fileid = uuidv4()
    const { filedata, fileerror } = await supabase
        .storage
        .from('Resumes')
        .upload(fileid, applicationdata.fileobject)
    const { data, error } = await supabase
    .from('applications')
    .insert([
        { name: applicationdata.name, phone: applicationdata.phone,email:applicationdata.email,resume:fileid,position:applicationdata.position,reference:applicationdata.reference,status:applicationdata.status },
    ])
    .select()
    if(data){
        return {data:data,success:true}
    }else if(error){
        return {error:error,success:false}
    }
    // dispatch({ type: ActionTypes.FETCH_JOBS, payload: Jobs });
};

export const updateApplication = (applicationdata) => async (dispatch) => {
    const { data, error } = await supabase
    .from('applications')
    .update({ status:applicationdata.status })
    .eq('id', applicationdata.id)
    .select()
    if(data){
        return {data:data,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};  

export const deleteApplication = (id) => async (dispatch) => {
    const { error } = await supabase
    .from('applications')
    .delete()
    .eq('id', id)
    if(!error){
        return {success:true}
    }else if(error){
        return {success:false}
    }
};